import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNoQualifySettlement = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety nie możemy zaoferować obsługi Twojej sprawy'
      )}
      withButton
    >
      <>
        <span>
          {i18n.t(
            'Ugoda kończy proces likwidacji szkody, uniemożliwiając nam dochodzenie dodatkowych roszczeń w przyszłości. Po jej podpisaniu nie masz już prawa domagać się dodatkowych środków lub rewaloryzacji odszkodowania, nawet jeśli okaże się, że szkoda była większa niż początkowo oszacowano.'
          )}
        </span>
        <span>
          {i18n.t(
            'Zawsze warto dokładnie rozważyć wszystkie za i przeciw, a w razie wątpliwości skonsultować się z nami, by mieć pewność, że podejmowana decyzja jest w pełni świadoma i odpowiada Twoim interesom.'
          )}
        </span>
        <span className="font-semibold">
          {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
        </span>
      </>
    </AfterDoc>
  );
};

export default ThankYouNoQualifySettlement;
